import * as styles from './TromanDialog.module.less';
import { Dialog, DialogProps } from "@mui/material";
import { PropsWithChildren } from "react";

export interface ITromanDialogProps {
    open: boolean;
    onClose?: DialogProps["onClose"];
}

const dialogSlotProps: DialogProps["slotProps"] = {
    paper: {
        style: {
            borderRadius: '6px',
            verticalAlign: 'top',
        }
    }
};

export const TromanDialog = ({children, ...props}: PropsWithChildren<ITromanDialogProps>) => {
    return (
        <Dialog {...props} scroll="body" maxWidth="md" fullWidth={true} slotProps={dialogSlotProps}>
            <div className="modal-content">
                {children}
            </div>
        </Dialog>
    );
}

export const TromanDialogHeader = ({children}: PropsWithChildren) => (<div className="modal-header">{children}</div>);
export const TromanDialogTitleHeader = ({title}: {title: string}) => (<div className="modal-header"><h3 className="modal-title">{title}</h3></div>);
export const TromanDialogBody = ({children}: PropsWithChildren) => (<div className="modal-body">{children}</div>);
export const TromanDialogBodySection = ({children}: PropsWithChildren) => (<div className={styles.section}>{children}</div>);
export const TromanDialogFooter = ({children}: PropsWithChildren) => (<div className={`modal-footer ${styles.footer}`}>{children}</div>);
